export default __webpack_public_path__ + "static/media/YAS0710.34I-34131_-18349_50.bae00193.jpg";